var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.root},[(_vm.currentPreviewSrc)?_c('iframe',{class:_vm.$style.content,attrs:{"src":_vm.currentPreviewSrc,"frameborder":"0"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }